import React, { useMemo } from "react";

const ELLIPSIS = "ellipsis";

const getPageItems = (currentPage, totalPages) => {
  const items = [];
  const siblingCount = 1;

  const startPage = Math.max(2, currentPage - siblingCount);
  const endPage = Math.min(totalPages - 1, currentPage + siblingCount);

  items.push(1);

  if (startPage > 2) {
    items.push(ELLIPSIS);
  }

  for (let page = startPage; page <= endPage; page++) {
    items.push(page);
  }

  if (endPage < totalPages - 1) {
    items.push(ELLIPSIS);
  }

  if (totalPages > 1) {
    items.push(totalPages);
  }

  return items;
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageItems = useMemo(() => getPageItems(currentPage, totalPages), [currentPage, totalPages]);

  if (totalPages <= 1) return null;

  const goToPage = page => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  return (
    <div className="pagination-container">
      <div className="pagination">
        <button type="button" className="page-btn page-nav" disabled={currentPage === 1} onClick={() => goToPage(currentPage - 1)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M12.5017 6.66829H0.834991M6.66833 0.834961L0.834991 6.66829L6.66833 12.5016" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>Previous</span>
        </button>
        {pageItems.map((item, index) =>
          item === ELLIPSIS ? (
            <span className="page-ellipsis" key={`ellipsis-${index}`}>
              &hellip;
            </span>
          ) : (
            <button type="button" key={item} className={`page-btn${item === currentPage ? " active" : ""}`} onClick={() => goToPage(item)}>
              {item}
            </button>
          ),
        )}
        <button type="button" className="page-btn page-nav" disabled={currentPage === totalPages} onClick={() => goToPage(currentPage + 1)}>
          <span>Next</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M0.835022 6.66829H12.5017M6.66836 12.5016L12.5017 6.66829L6.66836 0.834961" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
